
/**
 * GSC CONTRACTS FACADE - V71.3
 * Source de vérité unique pour les structures de données.
 */
export * from './contracts';
export * from './contracts/audio';
export * from './contracts/scoring';
export * from './contracts/social';
// export * from './contracts/pedagogy'; // removed: collisions with scoring exports
export * from './contracts/transfer';
export type { ActiveMission } from "./contracts/mission";
export type { UserExposureLevel } from "./contracts/exposure";


// Fixed missing utility function for structured grid conversion
export function tokensToStructuredGrid(tokens: string[]): string[][] {
    if (!tokens || tokens.length === 0) return [];
    const bars: string[][] = [];
    let currentBar: string[] = [];
    
    tokens.forEach(t => {
        const trimmed = t.trim();
        if (trimmed === '|') {
            if (currentBar.length > 0) {
                bars.push(currentBar);
                currentBar = [];
            }
        } else if (trimmed.length > 0) {
            currentBar.push(trimmed);
        }
    });
    
    if (currentBar.length > 0) {
        bars.push(currentBar);
    }
    
    return bars;
}

// Fixed missing global level definitions
export const GUITAR_LEVELS = [
    { id: 1, name: "Niveau 1", thresholds: { subdivisionsPerBeat: 1 } },
    { id: 2, name: "Niveau 2", thresholds: { subdivisionsPerBeat: 1 } },
    { id: 3, name: "Niveau 3", thresholds: { subdivisionsPerBeat: 2 } },
    { id: 4, name: "Niveau 4", thresholds: { subdivisionsPerBeat: 2 } },
    { id: 5, name: "Niveau 5", thresholds: { subdivisionsPerBeat: 2 } },
    { id: 6, name: "Niveau 6", thresholds: { subdivisionsPerBeat: 4 } },
    { id: 7, name: "Niveau 7", thresholds: { subdivisionsPerBeat: 4 } },
    { id: 8, name: "Niveau 8", thresholds: { subdivisionsPerBeat: 4 } },
];
